import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import axios from 'axios';

import { userModelGet, } from '../../models/users/user';
import { responseGet, globalSettings, styles, validateEmail, sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp, awaitDelay, } from '../../helpers/settings'
import { userProcessButtonsGet } from '../../controllers/users/users';
import { roleModelGet } from '../../models/roles/role';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'UsersAddEdit';

const { app, collections: dbColle, icons, images, labels, messages, react, } = globalSettings;
const { backend, } = app;
const { html: reactHtml, } = react;
const { properties: dbProps, } = dbColle;

export default function UsersAddEdit({
    $ = {},
    auth = {},
    showModal = false,
    setShowModal = () => { },
    user = userModelGet({}),
    setUser = () => { },
    roles = [roleModelGet({})],
    dtId = '',
    dtRowIndex = 0,
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const [errorFirstName, setErrorFirstName] = useState('');
    const [errorLastName, setErrorLastName] = useState('');
    const [errorPhoneNumber, setErrorPhoneNumber] = useState('');
    const [errorEmail, setErrorEmail] = useState('');
    const [errorRole, setErrorRole] = useState('');
    //const [userBeforeEdit] = useState(user);
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnUserModalSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnUserModalBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnUserModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            // inactive: {
            //     id: 'chkUserModalEnable',
            //     className: 'icheck-primary d-inline',
            // },
            // inactiveReadOnly: {
            //     id: 'chkUserModalReadOnly',
            //     className: 'icheck-primary d-inline',
            // },
        },
        dataTables: {
            // collectionCashes: {
            //     buttons: {
            //         add: {
            //             className: 'btn btn-outline-success float-right btn-sm',
            //             id: 'btndtCountryesIdAdd',
            //         },
            //         delete: {
            //             className: 'btn btn-outline-danger float-right btn-sm mx-1',
            //             id: 'btndtCountryesIdDelete',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icondtCountryesIdAdd',
            //             className: icons?.plusCircle,
            //         },
            //         delete: {
            //             id: 'icondtCountryesIdDelete',
            //             className: icons?.trash,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtCountryesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtCountryesId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spdtCountryesIdAdd',
            //             className: '',
            //         },
            //         delete: {
            //             id: 'spdtCountryesIdDelete',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoUserModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoUserModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoUserModalClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            firstName: {
                id: 'inputUserModalFirstName',
                className: 'form-control',
            },
            lastName: {
                id: 'inputUserModalLastName',
                className: 'form-control',
            },
            phoneNumber: {
                id: 'inputUserModalPhoneNumber',
                className: 'form-control',
            },
        },
        selects: {
            roles: {
                id: 'selUserModalRoles',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spUserModalSave',
                className: '',
            },
            back: {
                id: 'spUserModalBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region methods (user)
    const userEditPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'userEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            response = errorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = validateFormData({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            //#region update data
            dataObj = {
                user: user,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${user?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            user = response?.result?.userVzLa || {};
            //#endregion update data
            //#endregion data save

            //#region processButtons
            response = userProcessButtonsGet({
                user: user,
                languageObj: languageObj,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            $(`#${dtId}`)?.DataTable()?.row(dtRowIndex).data(response?.result);
            //#endregion processButtons

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion methods (user)

    //#region methods
    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataSet = ({
        property = '',
        value = '',
        subMethod = '',
    }) => {
        const currentMethod = 'formDataSet';
        let response = responseGet();
        try {
            setUser({
                ...user,
                [property]: value,
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
    }

    const validateFormData = ({
        subMethod = '',
    }) => {
        const currentMethod = 'validateFormData';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: user?.firstName, subMethod: currentMethod, })?.result) {
                setErrorFirstName(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.lastName, subMethod: currentMethod, })?.result) {
                setErrorLastName(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.phoneNumber, subMethod: currentMethod, })?.result) {
                setErrorPhoneNumber(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.email, subMethod: currentMethod, })?.result) {
                setErrorEmail(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (!validateEmail({ email: user?.email, })) {
                setErrorEmail(messages?.youMustEnterValidEmail?.[languageObj?.id]);
                response.isWarning = true;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const errorsDefaultSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'errorsDefaultSet';
        let response = responseGet();
        try {
            setErrorRole('');
            setErrorEmail('');
            setErrorLastName('');
            setErrorFirstName('');
            setErrorPhoneNumber('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const controlsStatusSet = ({
        processType = 0,
        subMethod = '',
    }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.firstName?.id}`)?.attr({ readOnly: processType !== 0, });
            //$(`#${controls?.checkBox?.inactive?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.lastName?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.inputs?.phoneNumber?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.selects?.roles?.id}`)?.attr({ disabled: processType !== 0, });
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
    }, [showModal]);
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt='banks'
                        src={images?.userLogo}
                        style={styles?.cardHeaderLogo}></img> - {labels?.user?.[languageObj?.id]} ({processType === 0 ? labels?.add?.[languageObj?.id]?.toLowerCase() : processType === 1 ? labels?.edit?.[languageObj?.id]?.toLowerCase() : labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processType === 1 ?
                userEditPostAsync({ e: e, subMethod: 'form - onSubmit', }) :
                e?.preventDefault()}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => processType === 0 ? null : userEditPostAsync(e)}> */}

                    {/*Header*/}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={labels?.user?.[languageObj?.id]}
                                    src={images?.userLogo}
                                    style={styles?.cardHeaderLogo}></img> - {labels?.user?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/*Body*/}
                    {/* <div className='card-body'> */}

                    <div><b>{labels?.personalInformation?.[languageObj?.id]}:</b></div>
                    <hr />

                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <input id={controls?.inputs?.firstName?.id}
                                className={controls?.inputs?.firstName?.className}
                                type='text'
                                placeholder={labels?.firstName?.[languageObj?.id]}
                                onChange={(e) => formDataSet({
                                    property: dbProps?.firstName,
                                    value: e?.target?.value,
                                    subMethod: 'input - firstName',
                                })}
                                onFocus={() => setErrorFirstName('')}
                                value={user?.firstName || ''}
                                tooltip='tooltip'
                                title={labels?.firstName?.[languageObj?.id]} />
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className='fas fa-user' />
                                </div>
                            </div>
                        </div>
                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorFirstName)}</div>
                    </div>

                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <input id={controls?.inputs?.lastName?.id}
                                className={controls?.inputs?.lastName?.className}
                                type='text'
                                placeholder={labels?.lastName?.[languageObj?.id]}
                                onChange={(e) => formDataSet({
                                    property: dbProps?.lastName,
                                    value: e?.target?.value,
                                    subMethod: 'input - lastName',
                                })}
                                onFocus={() => setErrorLastName('')}
                                value={user?.lastName || ''}
                                tooltip='tooltip'
                                title={labels?.lastName?.[languageObj?.id]} />
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className='fas fa-user' />
                                </div>
                            </div>
                        </div>
                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorLastName)}</div>
                    </div>

                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <input id={controls?.inputs?.phoneNumber?.id}
                                className={controls?.inputs?.phoneNumber?.className}
                                type='text'
                                placeholder={labels?.phoneNumber?.[languageObj?.id]}
                                onChange={(e) => formDataSet({
                                    property: dbProps?.phoneNumber,
                                    value: e?.target?.value,
                                    subMethod: 'input - phoneNumber',
                                })}
                                onFocus={() => setErrorPhoneNumber('')}
                                value={user?.phoneNumber || ''}
                                tooltip='tooltip'
                                title={labels?.phoneNumber?.[languageObj?.id]} />
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className='fas fa-mobile-alt prefix grey-text' />
                                </div>
                            </div>
                        </div>
                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorPhoneNumber)}</div>
                    </div>

                    <div><b>{labels?.accountInformation?.[languageObj?.id]}:</b></div>
                    <hr />

                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <input type='text'
                                className='form-control'
                                placeholder={labels?.email?.[languageObj?.id]}
                                onChange={(e) => formDataSet({
                                    property: dbProps?.email,
                                    value: e?.target?.value,
                                    subMethod: 'input - email',
                                })}
                                onFocus={() => setErrorEmail('')}
                                value={user?.email || ''}
                                tooltip='tooltip'
                                title={labels?.email?.[languageObj?.id]}
                                disabled />
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className={`${icons?.envelope} prefix grey-text`} />
                                </div>
                            </div>
                        </div>
                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorEmail)}</div>
                    </div>

                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <select id={controls?.selects?.roles?.id}
                                className={controls?.selects?.roles?.className}
                                defaultValue={user?.roleId || ''}
                                onChange={(e) => formDataSet({
                                    property: dbProps?.roleId,
                                    value: e?.target?.value,
                                    subMethod: currentMethod
                                })}
                                onFocus={() => setErrorRole('')}>
                                <option key='nothing' value=''>{messages?.selectRole?.[languageObj?.id]}</option>
                                {roles?.map(role => <option key={role?.id} value={role?.id}>{role?.description}</option>)}
                            </select>
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className={icons?.userTag} />
                                </div>
                            </div>
                        </div>
                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorRole)}</div>
                    </div>
                    {/* </div> */}

                    {/*Footer*/}
                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning mx-1'
                                    tooltip='tooltip'
                                    title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                    type='submit'>
                                    <i className={icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}

                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>

                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}